<script lang="ts">
  import { Link } from 'svelte-routing';
  import { DONATIONS_ENABLED } from '../lib/features';

  // Bottom-of-page legal footer for PageShell. Distinct from the
  // game-only AppFooter (which surfaces gameplay hints). Year is
  // computed at module load — the SPA reloads on deploy so this stays
  // fresh enough without a runtime tick.
  //
  // Link order + content mirror AppFooter so the chrome reads as one
  // piece across game and text-heavy routes. Donate is gated on the
  // same DONATIONS_ENABLED flag; Discord routes through /discord
  // (Cloudflare Pages 302) for the same Chrome-LNA reason as
  // AppFooter.

  const YEAR = new Date().getFullYear();
</script>

<footer class="legal-footer">
  <div class="legal-footer__inner">
    <span class="legal-footer__copy">© {YEAR} AtlasGuess</span>
    <nav class="legal-footer__links" aria-label="Legal and contact">
      <Link to="/privacy" getProps={() => ({ class: 'legal-footer__link' })}>Privacy</Link>
      <Link to="/terms" getProps={() => ({ class: 'legal-footer__link' })}>Terms</Link>
      <Link to="/contact" getProps={() => ({ class: 'legal-footer__link' })}>Contact</Link>
      {#if DONATIONS_ENABLED}
        <Link to="/donate" getProps={() => ({ class: 'legal-footer__link' })}>Donate</Link>
      {/if}
      <a href="/discord" target="_blank" rel="noopener noreferrer" class="legal-footer__link">
        Discord
      </a>
    </nav>
  </div>
</footer>
